var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwoGems(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "100 gems"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29944 8.67669L5.9729 10.4073L18.6561 7.28682L22.1775 3.47872C22.3877 3.25131 22.3464 2.89025 22.0902 2.71619L18.5099 0.285156L10.1867 0.934356L3.88 3.98385L1.11454 8.1042C0.976497 8.3099 1.06722 8.59065 1.29959 8.67669H1.29944Z",
    fill: "#8BEFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6564 7.28682L22.4288 3.20716C22.5069 3.12277 22.4915 2.98865 22.3964 2.924L18.5101 0.285156L16.3834 3.69406L18.6564 7.28667V7.28682Z",
    fill: "#00B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.97205 10.4064L18.6554 7.28612L16.3823 3.69336L7.10213 5.9404L5.97205 10.4064Z",
    fill: "#57D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49063 8.74579L5.97316 10.4057L7.10325 5.93967L3.88011 3.98242L1.22827 7.93353C1.03236 8.22543 1.16106 8.62373 1.49079 8.74594L1.49063 8.74579Z",
    fill: "#00B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.1175 8.70433L14.9359 18.5939C14.9745 18.6215 15.0182 18.5673 14.983 18.5355L5.97255 10.4075L1.15955 8.62522C1.11012 8.60683 1.07455 8.67374 1.1175 8.70448V8.70433Z",
    fill: "#00518A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6565 7.28711L5.97327 10.4076L14.7623 18.3359C15.0902 18.6317 15.6149 18.4775 15.7307 18.0514L18.6565 7.28711Z",
    fill: "#1996DB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3566 3.28429L18.6555 7.28694L15.7429 18.0024C15.7176 18.0955 15.8504 18.1428 15.8897 18.0547L22.4446 3.34216C22.4692 3.287 22.3978 3.23983 22.3568 3.28414L22.3566 3.28429Z",
    fill: "#006FB1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M14.6291 0.524894L10.4358 5.12084L11.4405 4.87761L15.3856 0.46582L14.6291 0.524894Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.9571 0.7984L7.10266 5.94333L9.72044 5.3095L13.9555 0.642578L11.9571 0.7984Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1666 0.282522L10.3621 0.891186C10.2423 0.900529 10.1252 0.932176 10.017 0.984468L4.10947 3.84092C3.95531 3.91552 3.8236 4.02974 3.72821 4.172L1.35968 7.70086C1.06883 8.13411 1.17508 8.72002 1.59944 9.02367L14.5191 18.27C15.0111 18.6221 15.7025 18.4344 15.9488 17.8816L22.2426 3.75517C22.4327 3.32825 22.2897 2.82628 21.903 2.56377L18.784 0.446029C18.6027 0.32291 18.3851 0.265192 18.1668 0.28222L18.1666 0.282522Z",
    stroke: "#002E41",
    strokeWidth: 0.518399,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M18.6565 7.28809L5.96481 10.2408L2.1969 9.01009L5.9731 10.4084L18.6565 7.28809Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.12,
    d: "M5.97327 10.4097L13.6354 17.3214L6.20218 10.3535L5.97327 10.4097Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M18.7527 7.23535L15.9537 17.1673L18.5289 7.30965L18.7527 7.23535Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M7.10322 5.94238L5.96484 10.2409L6.15035 10.2237L7.10322 5.94238Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M16.3834 3.69629L18.5856 7.35776L18.7527 7.2366L16.3834 3.69629Z",
    fill: "#D0FAFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M26.5404 11.563L27.8392 11.8108L25.4885 7.9082L25.1803 9.30501L26.5404 11.563Z",
    fill: "#006FB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M25.6619 16.2448L26.2859 17.5786C26.3911 17.8036 26.7229 17.7614 26.7687 17.5174L27.8393 11.8102L26.5404 11.5625L25.662 16.2449L25.6619 16.2448Z",
    fill: "#00518A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M17.6325 18.1729L16.2058 18.9459L22.4578 20.8173L23.8846 20.0442L17.6325 18.1729Z",
    fill: "#00518A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M16.4984 7.78223L15.0716 8.5553L13.8547 15.0428L15.2814 14.2702L16.4984 7.78223Z",
    fill: "#00A7E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M16.2056 18.9459L13.8547 15.0431L15.2814 14.2705L17.6323 18.1728L16.2056 18.9459Z",
    fill: "#006FB1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M25.1809 9.30511L25.4891 7.90831L19.2372 6.03711L20.6682 7.95442L25.1809 9.30511Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M23.6439 17.4944L23.135 20.4556L25.9089 18.7408C26.3155 18.4894 26.4692 17.9736 26.2668 17.5407L25.6616 16.2471L23.6441 17.4942L23.6439 17.4944Z",
    fill: "#006FB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M20.668 7.95442L19.2369 6.03711L15.7496 8.19237L18.6504 9.20159L20.668 7.95442Z",
    fill: "#00B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M19.1322 16.1426L16.8838 18.5831L23.1358 20.4545L23.6449 17.4933L19.1322 16.1426Z",
    fill: "#009BD2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M18.6505 9.2016L15.7498 8.19238L14.5327 14.6803L17.7721 13.884L18.6505 9.2016Z",
    fill: "#57D3FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M20.6681 7.95508L18.6505 9.20224L17.7721 13.8847L19.1321 16.1427L23.6448 17.4934L25.6624 16.2462L26.5408 11.5638L25.1807 9.30577L20.6681 7.95508Z",
    fill: "#8BEFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M21.9982 8.35059L25.1805 9.30314L25.3659 9.61116L17.8411 13.5138L18.4657 10.1825L21.9982 8.35059Z",
    fill: "#D0FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M26.4452 12.0664L26.0437 14.209L21.1521 16.7457L19.1315 16.1408L19.0022 15.9262L26.4452 12.0664Z",
    fill: "#D0FAFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M17.7719 13.8848L14.5325 14.681L16.8835 18.5833L19.1319 16.1428L17.7719 13.8848Z",
    fill: "#00B8FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M23.6476 20.027L25.473 18.8986C26.091 18.5166 26.5194 17.8919 26.6534 17.1779L27.5608 12.3407C27.6247 11.9997 27.5612 11.6472 27.3822 11.35L25.6455 8.4669C25.4291 8.10764 25.0868 7.84212 24.685 7.72186L19.7523 6.24549C19.3099 6.11303 18.8322 6.17375 18.4369 6.41276L15.4588 8.21298C15.098 8.43104 14.8474 8.79256 14.7698 9.20683L13.7903 14.4289C13.716 14.8246 13.7898 15.2338 13.9975 15.5787L15.719 18.4368C15.9163 18.7644 16.2287 19.0068 16.5951 19.1163L21.7569 20.6613C22.0904 20.761 22.4498 20.724 22.7559 20.5582L23.6477 20.0271L23.6476 20.027Z",
    stroke: "#002E41",
    strokeWidth: 0.518399,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M18.6502 9.20117L17.6316 13.918L19.1318 16.1417L17.7717 13.8836L18.6502 9.20117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M17.6322 13.9199L14.533 14.6818L17.735 14.0723L17.6322 13.9199Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M7.16378 6.95523C7.16378 5.87021 7.08271 5.78914 5.99768 5.78914C7.08271 5.78914 7.16378 5.70806 7.16378 4.62305C7.16378 5.70806 7.24486 5.78914 8.32989 5.78914C7.24486 5.78914 7.16378 5.87021 7.16378 6.95523Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M18.6499 10.2277C18.6499 9.14267 18.5688 9.0616 17.4838 9.0616C18.5688 9.0616 18.6499 8.98052 18.6499 7.89551C18.6499 8.98052 18.7309 9.0616 19.816 9.0616C18.7309 9.0616 18.6499 9.14267 18.6499 10.2277Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoGems);
export default __webpack_public_path__ + "static/media/two-gems.c6aff387ad3ab4bc565fdcfe231c30ff.svg";
export { ForwardRef as ReactComponent };